import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_scam_settings(params = {}) {
  return request({
    url: global.endpoint.SCAM_SETTINGS,
    method: "get",
    params
  });
}

async function update_scam_settings(data = {}) {
  return request({
    url: global.endpoint.SCAM_SETTINGS,
    method: "put",
    data
  });
}

async function get_whitelist_urls(params = {}) {
  return request({
    url: global.endpoint.SCAM_SETTINGS_WHITELIST_URLS,
    method: "get",
    params
  });
}

async function create_whitelist_url(url) {
  return request({
    url: global.endpoint.SCAM_SETTINGS_WHITELIST_URLS,
    method: "post",
    data: { url }
  });
}

async function delete_whitelist_url(url) {
  return request({
    url: `${global.endpoint.SCAM_SETTINGS_WHITELIST_URLS}/${url}`,
    method: "delete",
  });
}

export default {
  get_scam_settings,
  update_scam_settings,
  get_whitelist_urls,
  create_whitelist_url,
  delete_whitelist_url
};
